import { Link } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { Link as RouterLink } from "react-router-dom";
import { SystemChat } from "../systemChat/type";

export default function SystemChatDetailButton(
  props: GridCellParams<SystemChat, any>
) {
  return (
    <Link component={RouterLink} to={`/systemChats/${props.row.userId}`}>
      Detay
    </Link>
  );
}
